/**
 * Url定数
 */
export class MobileUrl {
  /** 基底URL、ログイン画面を指す */
  public static readonly Root: string = "/";
  /** モバイルprefix */
  public static readonly MobilePrefix: string = "/mobile";
  /** ダッシュボード */
  public static readonly Dashboard: string = MobileUrl.MobilePrefix + "/dashboard";
  /** ホーム */
  public static readonly Home: string = MobileUrl.MobilePrefix + "/home";

  /** 面会予約 */
  public static readonly ReservationList: string = MobileUrl.MobilePrefix + "/reservation/list";
  /** 面会予約詳細 */
  public static readonly ReservationDetail: string = MobileUrl.MobilePrefix + "/reservation/list/detail";

  /** 外出外泊届け */
  public static readonly OutingList: string = MobileUrl.MobilePrefix + "/outing/list";
  /** 外出外泊届け詳細 */
  public static readonly OutingDetail: string = MobileUrl.MobilePrefix + "/outing/list/detail";
  /** 外出外泊届け詳細 */
  public static readonly OutingEdit: string = MobileUrl.MobilePrefix + "/outing/list/edit";

  /** メッセージ登録入力 */
  public static readonly MessageRegisterInput: string = MobileUrl.MobilePrefix + "/message/register";
  /** メッセージ登録入力確認 */
  public static readonly MessageRegisterConfirm: string = MobileUrl.MobilePrefix + "/message/register/confirm";
  /** メッセージ登録完了 */
  public static readonly MessageRegisterComplete: string = MobileUrl.MobilePrefix + "/message/register/complete";
  /** メッセージ履歴(家族) */
  public static readonly FamilyMessageList: string = MobileUrl.MobilePrefix + "/message/family/list";
  /** メッセージ履歴詳細(家族) */
  public static readonly FamilyMessageHistoryDetail: string = MobileUrl.MobilePrefix + "/message/family/detail";
  /** メッセージ履歴返信詳細(家族) */
  public static readonly FamilyMessageReplyDetail: string = MobileUrl.MobilePrefix + "/message/family/reply/detail";
  /** メッセージ履歴(施設関係者) */
  public static readonly OtherUserMessageList: string = MobileUrl.MobilePrefix + "/message/other-user/list";
  /** メッセージ履歴詳細(施設関係者) */
  public static readonly OtherUserMessageHistoryDetail: string = MobileUrl.MobilePrefix + "/message/other-user/detail";
  /** メッセージ履歴返信詳細(施設関係者) */
  public static readonly OtherUserMessageeReplyHistoryDetail: string = MobileUrl.MobilePrefix + "/message/other-user/reply/detail";

  /** 受信メッセージ(家族) */
  public static readonly FamilyReceiveMessageList: string = MobileUrl.MobilePrefix + "/receive-message/family/list";
  /** 受信メッセージ詳細(家族) */
  public static readonly FamilyReceiveMessageDetail: string = MobileUrl.MobilePrefix + "/receive-message/family/detail";
  /** 受信メッセージ返信(家族) */
  public static readonly FamilyReplyReceiveMessageConfirm: string = MobileUrl.MobilePrefix + "/receive-message/family/reply-confirm";
  /** 受信メッセージ(施設関係者) */
  public static readonly OtherUserReceiveMessageList: string = MobileUrl.MobilePrefix + "/receive-message/other-user/list";
  /** 受信メッセージ詳細(施設関係者) */
  public static readonly OtherUserReceiveMessageDetail: string = MobileUrl.MobilePrefix + "/receive-message/other-user/detail";
  /** 受信メッセージ返信(施設関係者) */
  public static readonly OtherUserReplyReceiveMessageConfirm: string = MobileUrl.MobilePrefix + "/receive-message/other-user/reply-confirm";

  /** 新着メッセージ */
  public static readonly NewArrivalMessagesList: string = MobileUrl.MobilePrefix + "/new-arrival-messages/list";

  /** 安否確認一覧 */
  public static readonly SafetyConfirmList: string = MobileUrl.MobilePrefix + "/safety-confirm/list";
  /** 安否確認送信(施設関係者) 入力 */
  public static readonly SendSafetyConfirmToOtherUserInput: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/send/input";
  /** 安否確認送信(施設関係者) 確認 */
  public static readonly SendSafetyConfirmToOtherUserConfirm: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/send/confirm";
  /** 安否確認送信(施設関係者) 完了 */
  public static readonly SendSafetyConfirmToOtherUserComplete: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/send/complete";
  /** 安否確認送信(施設関係者) 詳細 */
  public static readonly SendSafetyConfirmToOtherUserDetail: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/send/detail";
  /** 安否確認事前設定(施設関係者) 入力 */
  public static readonly SafetyConfirmOtherUserTempleteInput: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/template";
  /** 安否確認事前設定(施設関係者) 確認 */
  public static readonly SafetyConfirmOtherUserTempleteConfirm: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/template/confirm";
  /** 安否確認事前設定(施設関係者) 完了 */
  public static readonly SafetyConfirmOtherUserTempleteComplete: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/template/complete";
  /** 安否確認登録 入力  */
  public static readonly SafetyConfirmRegisterInput: string = MobileUrl.MobilePrefix + "/safety-confirm/register/input";
  /** 安否確認登録 確認 */
  public static readonly SafetyConfirmRegisterConfirm: string = MobileUrl.MobilePrefix + "/safety-confirm/register/confirm";
  /** 安否確認登録 完了 */
  public static readonly SafetyConfirmRegisterComplete: string = MobileUrl.MobilePrefix + "/safety-confirm/register/complete";
  /** 安否確認 安否確認入力依頼(施設関係者) */
  public static readonly SafetyConfirmOtherUserRegister: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/register";
  /** 安否確認 安否確認詳細(施設関係者) */
  public static readonly SafetyConfirmOtherUserDetail: string = MobileUrl.MobilePrefix + "/safety-confirm/other-user/detail";
}
